export default __webpack_public_path__ + "static/media/Gilroy-Medium.3a98bbb5.woff";